import { useEffect, RefObject, useRef } from 'react';
import playerjs from 'player.js';
import isInIframe from '@anm/helpers/is/isInIframe';

const usePlayerJS = (videoRef: RefObject<HTMLVideoElement>) => {
  const isIframe = isInIframe();
  const isInited = useRef(false);

  useEffect(() => {
    const video = videoRef.current;
    if (!video || !isIframe || isInited.current) return;

    const adapter = playerjs.HTML5Adapter(videoRef.current);

    adapter.ready();
    isInited.current = true;
  }, [videoRef.current, isIframe, isInited.current]);
};

export default usePlayerJS;
